import { HubConnectionBuilder } from "@microsoft/signalr";
import { GetStorage } from "../../Utils/Storage";
import { connect } from "mqtt";

export const SocketConnection = async () => {
  const token = GetStorage("check_user_tenant_token") || GetStorage("optime_token");

  const connection = new HubConnectionBuilder()
    .withUrl(process.env.REACT_APP_API_BASE_URL + "/planning_channel", {
      accessTokenFactory: () => token,
    })
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: retryContext => {
        if (retryContext.elapsedMilliseconds < 60 * 60 * 1000) {
          return 8000;
        } else {
          return null;
        }
      },
    })
    .build();
  // const startConnection =  connection.start();
  const myPromise = new Promise(async (resolve, reject) => {
    try {
      await connection.start();
      resolve(connection)
    } catch (e) {
      reject(e)
    }
  }
  )

  return myPromise;
};

export const MQTTConnection = () => {
  const token = GetStorage("optime_token");

  // console.log("dataaaaaaaaaaaa******************", {
  //   username: token,
  //   password: process.env.REACT_APP_API_MQTT_PASSWORD,
  //   clientId: Math.random(),
  //   reconnectPeriod: 5000,
  // })

  const client = connect(process.env.REACT_APP_API_MQTT_CONNECTION, {
    username: token,
    password: process.env.REACT_APP_API_MQTT_PASSWORD,
    clientId: Math.random(),
    reconnectPeriod: 5000,
  });

  // console.log('client', client)

  return client;
};

// export const MQTTConnection = () => {
//   const token = GetStorage("optime_token");

//   const client = connect("mqtt://185.226.117.139:1883", {
//     port: "1883",
//     protocol: 'mqtt',
//     username: "test",
//     password: "123",

//     clientId: Math.random(),
//     reconnectPeriod: 5000,
//   });

//   return client;
// };